/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { ClonableMixin as o } from "../../core/Clonable.js";
import { JSONMap as r } from "../../core/jsonMap.js";
import { JSONSupport as t } from "../../core/JSONSupport.js";
import { property as i } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import { subclass as s } from "../../core/accessorSupport/decorators/subclass.js";
const a = new r({
    esriRelCardinalityOneToOne: "one-to-one",
    esriRelCardinalityOneToMany: "one-to-many",
    esriRelCardinalityManyToMany: "many-to-many"
  }),
  n = new r({
    esriRelRoleOrigin: "origin",
    esriRelRoleDestination: "destination"
  });
let l = class extends o(t) {
  constructor(e) {
    super(e), this.cardinality = null, this.composite = null, this.id = null, this.keyField = null, this.keyFieldInRelationshipTable = null, this.name = null, this.relatedTableId = null, this.relationshipTableId = null, this.role = null;
  }
};
e([i({
  json: {
    read: a.read,
    write: a.write
  }
})], l.prototype, "cardinality", void 0), e([i({
  json: {
    read: !0,
    write: !0
  }
})], l.prototype, "composite", void 0), e([i({
  json: {
    read: !0,
    write: !0
  }
})], l.prototype, "id", void 0), e([i({
  json: {
    read: !0,
    write: !0
  }
})], l.prototype, "keyField", void 0), e([i({
  json: {
    read: !0,
    write: !0
  }
})], l.prototype, "keyFieldInRelationshipTable", void 0), e([i({
  json: {
    read: !0,
    write: !0
  }
})], l.prototype, "name", void 0), e([i({
  json: {
    read: !0,
    write: !0
  }
})], l.prototype, "relatedTableId", void 0), e([i({
  json: {
    read: !0,
    write: !0
  }
})], l.prototype, "relationshipTableId", void 0), e([i({
  json: {
    read: n.read,
    write: n.write
  }
})], l.prototype, "role", void 0), l = e([s("esri.layers.support.Relationship")], l);
const p = l;
export { p as default };